export const getCategoryName = (category) => {
  switch (category) {
    case 0:
      return 'Icons';
    case 1:
      return 'Logos';
    case 2:
      return 'Illustrations';
    case 3:
      return 'Backgrounds | Patterns | Shapes';
    default:
      return '';
  }
};

export const getIconCategory = (name) => {
  const lowerName = name.toLowerCase();

  if (lowerName.includes('logo') && !lowerName.includes('logout')) return 1; // Logos
  if (lowerName.includes('illustration') || lowerName.includes('ilustration')) return 2; // Illustrations
  if (
    lowerName.includes('bg') ||
    lowerName.includes('background') ||
    lowerName.includes('pattern') ||
    lowerName.includes('shape-')
  )
    return 3; // Backgrounds/Patterns
  return 0; // Regular Icons
};

export const isLightIcon = (name) => {
  const lowerName = name.toLowerCase();
  return lowerName.includes('white');
};

export const getIconFamily = (name) => {
  // Extract the family name by removing the last part after the final hyphen
  // Examples: "context-menu-vertical" -> "context-menu", "card-add-linear" -> "card-add"
  const lastHyphenIndex = name.lastIndexOf('-');

  if (lastHyphenIndex > 0) {
    return name.substring(0, lastHyphenIndex); // Return everything before the last hyphen
  }

  return 'unknown';
};

export const getIconType = (name) => {
  // Extract the last part after the final hyphen
  // Examples: "context-menu-vertical" -> "vertical", "card-add-linear" -> "linear"
  const lastHyphenIndex = name.lastIndexOf('-');

  if (lastHyphenIndex > 0 && lastHyphenIndex < name.length - 1) {
    return name.substring(lastHyphenIndex + 1); // Return everything after the last hyphen
  }

  return name; // If no hyphen, return the full name
};
